<div class="main-container">
  <ng-container [ngSwitch]="layout">

    <div *ngSwitchCase="'terka'">
      <h1>Svatební Pacman</h1>
      <app-pacman></app-pacman>
    </div>

    <div *ngSwitchCase="'janko'">
      <h1>Poukázka na web</h1>
      <app-game></app-game>
    </div>

  </ng-container>
</div>
